import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=4e476c22&scoped=true&"
import script from "./UsersView.vue?vue&type=script&lang=js&"
export * from "./UsersView.vue?vue&type=script&lang=js&"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=4e476c22&prod&lang=scss&scoped=true&"
import style1 from "./UsersView.vue?vue&type=style&index=1&id=4e476c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e476c22",
  null
  
)

export default component.exports